import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  type User as FirebaseUser,
} from 'firebase/auth';

import { auth } from '../../../lib/firebase.js';

/**
 * Admin/staff accounts are provisioned by a super_admin (via the Users
 * page or a one-time seed script), never self-registered — so this module
 * only exposes sign-in, not sign-up, unlike customer-web's equivalent.
 */
export async function signInWithEmail(email: string, password: string): Promise<FirebaseUser> {
  const credential = await signInWithEmailAndPassword(auth, email, password);
  return credential.user;
}

const SIGN_IN_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Incorrect email or password',
  'auth/invalid-login-credentials': 'Incorrect email or password',
  'auth/wrong-password': 'Incorrect email or password',
  'auth/user-not-found': 'Incorrect email or password',
  'auth/invalid-email': 'Enter a valid email address',
  'auth/user-disabled': 'This account has been disabled',
  'auth/too-many-requests': 'Too many failed attempts — wait a few minutes and try again',
  'auth/network-request-failed': 'Network error — check your connection and try again',
};

/** Turns a Firebase sign-in failure into something a person can act on. */
export function getSignInErrorMessage(error: unknown): string {
  const code =
    typeof error === 'object' && error !== null && 'code' in error ? String(error.code) : '';
  return SIGN_IN_ERROR_MESSAGES[code] ?? 'Could not sign in — please try again';
}

export async function signOut(): Promise<void> {
  await firebaseSignOut(auth);
}
